"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOOnboardingPopupStore = void 0;
const mobx_1 = require("mobx");
const DOOnboardingPopup_1 = require("./DOOnboardingPopup");
class DOOnboardingPopupStore {
    constructor(parentStore) {
        this.story = parentStore;
        this.data = {};
        (0, mobx_1.makeObservable)(this, {
            data: mobx_1.observable,
        });
    }
    getById(id) {
        return this.data[id];
    }
    merge(data) {
        const id = data.popupId;
        if (!this.data[id]) {
            this.data[id].merge(data);
        }
        else {
            this.data[id] = new DOOnboardingPopup_1.DOOnboardingPopup(data);
        }
        return this.data[id];
    }
}
exports.DOOnboardingPopupStore = DOOnboardingPopupStore;
